import { ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Dictionary } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { StringAnyMap } from 'src/app/core/models/common.models';
import { CategoriesStoreService } from 'src/app/core/store/services/categories-store.service';
import { BaseMultiSelectComponent } from '../craft-multi-select/craft-multi-select.component';

@Component({
  selector: 'craft-categories-multi-select',
  templateUrl: './craft-categories-multi-select.component.html',
  styleUrls: ['./craft-categories-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftCategoriesMultiSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftCategoriesMultiSelectComponent extends BaseMultiSelectComponent implements OnInit {
  @Input() public items: Readonly<StringAnyMap>;

  public isEmptyList: boolean = false;
  public categoriesNames: Dictionary<string> = {};
  public buttonText = { other: 'Categories (#)' };

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private categoriesStore: CategoriesStoreService,
  ) {
    super(changeDetectorRef);
    this.idFieldName = 'id';
    this.labelFieldName = 'name';
  }

  public ngOnInit() {
    this.categoriesStore.list$.pipe(takeUntil(this.destroy$)).subscribe((categories) => {
      this.setItems(categories, this.selectedIds);
      this.isEmptyList = categories.length === 0;
      this.categoriesNames = categories.reduce<Dictionary<string>>((acc, category) => {
        acc[category.id] = category.name;
        return acc;
      }, {});
    });
  }

  public getSelectedCategoryName() {
    if (this.selectedSet.size === 0) return '';
    const id = Array.from(this.selectedSet.values())[0];
    return this.categoriesNames[id] || '';
  }
}
